window.addEventListener('klaviyoForms', function (e) {
  if (e.detail.type == 'submit') {
    if (typeof gtag === 'function') {
      gtag('event', 'form_submit', { form: 'Klaviyo form', form_id: e.detail.formId });
      gtag('event', 'conversion', { send_to: '1000059778/KARNCLuajrwaEILn7twD', value: 1.0, currency: 'GBP' });
    }
    if (typeof fbq === 'function') {
      console.log('In FB');
      fbq('trackCustom', 'form_submit', { form: 'Klaviyo form', form_id: e.detail.formId });
    }
  }
});
